<template>
<div>
  <Card dis-hover>
    <Row>
      <Col span="8">
        </br>
      </Col>
      <Col span="8">
        <Card style="width: 400px">
          <p slot="title">修改密码</p>
          <Form ref="formInline" :model="formInline" :rules="ruleInline" >
              <FormItem prop="user">
                  <Input type="text" v-model="formInline.user" placeholder="用户名">
                      <Icon type="ios-person-outline" slot="prepend"></Icon>
                  </Input>
              </FormItem>
              <FormItem prop="oldpassword" v-if="needVarifyPwd()">
                  <Input type="password" v-model="formInline.old_password" placeholder="旧密码">
                      <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </Input>
              </FormItem>
              <FormItem prop="newpassword">
                  <Input type="password" v-model="formInline.new_password" placeholder="新密码">
                      <Icon type="ios-lock-outline" slot="prepend"></Icon>
                  </Input>
              </FormItem>
              <FormItem>
                  <Button type="primary" @click="submitChangePwd(formInline)">修改</Button>
              </FormItem>
          </Form>
        </Card>
      </Col>
      <Col span="8">
        </br>
      </Col>
    </Row>
  </Card>
</div>
</template>
<script>
import store from '@/store'
import { changePwd } from '@/api/user'
export default {
  name: 'change_password_page',
  data () {
    return {
      isAdmin: true,
      formInline: {
        user: '',
        old_password: '',
        new_password: ''
      },
      ruleInline: {
        user: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        old_password: [
          { required: true, message: '请填写旧密码', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请填写新密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.isAdmin = store.state.user.access === 'admin'
    this.formInline.user = store.state.user.username
  },
  methods: {
    needVarifyPwd () {
      return !this.isAdmin || this.formInline.user === store.state.user.username
    },
    submitChangePwd (data) {
      changePwd(data).then(res => {
        if (res.data.ok) {
          this.$Notice.success({
            title: '密码修改成功', desc: res.data.msg
          })
        } else {
          this.$Notice.warning({
            title: '密码修改失败', desc: res.data.msg
          })
        }
      })
    }
  }
}
</script>
<style>
</style>
